// extracted by mini-css-extract-plugin
export default {"fadeIn":"HelpSupport_fadeIn__tZiVs","scroll-container":"HelpSupport_scroll-container__iE6yA","resource-card":"HelpSupport_resource-card__pW6qa"};